// Used to retrieve environment variables defined in the window object
// !WARN: window.__dacSettings object is only to be used in this file. Do not use it elsewhere.
// For each new variable to be added, don't forget to update the files generate-settings.sh, settings.js.tmpl and react-app-env.d.ts
// You'll need to stop and re-run the app for new variables to be loaded
const config = {
    DAC_SERVER_URL: window.__dacSettings.DAC_SERVER_URL,
};

export default config;
